// import { HttpClient } from '@angular/common/http';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { AfterViewInit, Component, EventEmitter, inject, Input, Output, signal, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IContacForm, IInfoDataEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'lib-web-shared-ui-contact-form',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule, FormsModule, MatIconModule, CdkTextareaAutosize],
  templateUrl: './lib-contact-form.component.html',
  styleUrl: './lib-contact-form.component.scss',
})
export class LibContactFormComponentComponent implements AfterViewInit {
  @ViewChild('franchiseForm') form!: NgForm;

  @Input() set data(value: IContacForm) {
    this.loggingService.log('||| IContacForm :: =>', value);
    this.dataSignal.set(value);
  }

  @Output() emitFormData = new EventEmitter();

  private readonly loggingService = inject(LoggingService);

  showMessageSuccess = signal<boolean>(false);

  // Pattern for names: A-Z, a-z, Thai (ก-ฮ, ะ-์), special chars, and spaces
  namePattern = /^[a-zA-Z\u0E01-\u0E4F\s.'-]+$/;

  ngAfterViewInit() {
    this.form.valueChanges!.subscribe((res) => {
      if (res.tel && !this.isOnlyNumbers(res.tel)) {
        // Remove non-numeric characters from `tel`
        const numericValue = res.tel.replace(/[^0-9]/g, '');
        this.form.controls['tel'].setValue(numericValue, { emitEvent: false });
      }

      // Sanitize name field - collapse multiple spaces
      if (res.name) {
        const sanitizedName = this.sanitizeName(res.name);
        if (sanitizedName !== res.name) {
          this.form.controls['name'].setValue(sanitizedName, { emitEvent: false });
        }
      }

      // Sanitize lastname field - collapse multiple spaces
      if (res.lastname) {
        const sanitizedLastname = this.sanitizeName(res.lastname);
        if (sanitizedLastname !== res.lastname) {
          this.form.controls['lastname'].setValue(sanitizedLastname, { emitEvent: false });
        }
      }
    });
  }

  // Checks if the string contains only numbers
  isOnlyNumbers(value: string): boolean {
    return /^[0-9]*$/.test(value);
  }

  // Sanitize name: collapse multiple consecutive spaces to single
  sanitizeName(value: string): string {
    return value.replace(/  +/g, ' ');
  }

  dataSignal = signal<IContacForm>({
    companyName: '',
    contactInfo: [] as IInfoDataEntity[],
  });

  franchiseFormSignal = signal<any>({
    name: '',
    lastname: '',
    tel: '',
    email: '',
    note: '',
    website: '',
  });

  manageFranchise() {
    // Honeypot check - silently reject if filled
    if (this.form.value.website) {
      this.loggingService.log('honeypot input', this.form.value.website);
      this.resetForm();
      return;
    }

    this.loggingService.log('franchiseFormSignal', this.franchiseFormSignal());
    this.loggingService.log('FormGroupDirective', !this.form.invalid);

    if (!this.form.invalid) {
      // Trim leading/trailing spaces before emitting
      const formValue = {
        ...this.form.value,
        name: this.form.value.name?.trim(),
        lastname: this.form.value.lastname?.trim(),
      };
      this.emitFormData.emit(formValue);
      this.resetForm();
      this.showMessageSuccess.set(true);
      setTimeout(() => {
        this.showMessageSuccess.set(false);
      }, 4000);
    }
  }

  resetForm() {
    this.franchiseFormSignal.set({
      name: '',
      lastname: '',
      tel: '',
      email: '',
      note: '',
      website: '',
    });
    this.form.resetForm();
  }
}
